import { MessageOutlined } from '@ant-design/icons';
import {
	Table,
	Select,
	DatePicker,
	Row,
	Col,
	Button,
	Modal,
	Typography,
	message as Toast,
} from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { commonSearch } from 'store/commonSlice';

const { RangePicker } = DatePicker;
const { Text } = Typography;

export default function MessageLogs() {
	const [logs, setLogs] = useState([]);
	const [groupList, setGroupList] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [group, setGroup] = useState(null);
	const [dates, setDates] = useState(null);
	const [showSentMessage, setShowSentMessage] = useState(false);
	const [messageText, setMessageText] = useState('');
	const dispatch = useDispatch();

	const paginationLimit = 10;

	useEffect(() => {
		dispatch(
			commonSearch({
				search_type: 'whatsapp_logs',
				limit: paginationLimit,
				offset: paginationLimit * (currentPage - 1),
			})
		)
			.then((res) => setLogs(res))
			.catch(() => Toast.error('Failed to fetch logs. Try Refresh.'));

		dispatch(commonSearch({ search_type: 'whatsapp_group_list' })).then((res) =>
			setGroupList(res.rows)
		);
	}, [dispatch]);

	useEffect(() => {
		fetchLogs();
	}, [group, dates, currentPage]);

	const fetchLogs = async () => {
		dispatch(
			commonSearch({
				search_type: 'whatsapp_logs',
				start_date: dates?.[0],
				end_date: dates?.[1],
				group_id: group,
				limit: paginationLimit,
				offset: paginationLimit * (currentPage - 1),
			})
		)
			.then((res) => setLogs(res))
			.catch(() => Toast.error('Failed to fetch logs. Try Refresh.'));
	};

	const handleGroupChange = (value) => {
		setGroup(value);
	};

	const handleDateChange = (logDateRange) => {
		setDates(logDateRange);
	};

	const updateCurrentPage = (pageNo) => {
		setCurrentPage(pageNo);
	};

	const showMessage = async (id) => {
		dispatch(commonSearch({ search_type: 'whatsapp_log_message', id }))
			.then((res) => {
				setMessageText(res?.rows?.[0].message);
				setShowSentMessage(true);
			})
			.catch(() => Toast.error('Failed to fetch message text.'));
	};

	const handleCancel = () => {
		setShowSentMessage(false);
	};

	const handleLiveClick = () => {
		setDates(null);
		setGroup(null);
	};

	const columns = [
		{
			title: 'Group Name',
			dataIndex: 'group_name',
			key: 'group_name',
			width: '40%',
		},
		{
			title: 'Message Type',
			dataIndex: 'message_type',
			key: 'message_type',
			width: '20%',
		},
		{
			title: 'Sent On',
			dataIndex: 'sent_on',
			key: 'sent_on',
			render: (sent_on) =>
				moment.utc(sent_on).utcOffset('+05:30').format('DD-MMM-YYYY hh:mm:ss A'),
			width: '20%',
		},
		{
			title: 'Show Message',
			dataIndex: 'id',
			key: 'id',
			render: (_, record) => (
				<Button icon={<MessageOutlined />} onClick={() => showMessage(record.id)} />
			),
			width: '20%',
			align: 'center',
		},
	];

	return (
		<div>
			<Row gutter={16} style={{ marginBottom: 16 }}>
				<Col span={10}>
					<Select
						placeholder="Select Group"
						onChange={handleGroupChange}
						style={{ width: '100%' }}
						options={groupList}
					/>
				</Col>
				<Col span={12}>
					<RangePicker
						value={dates}
						onChange={handleDateChange}
						showTime={{ format: 'HH:mm:ss' }}
						format="YYYY-MM-DD HH:mm:ss"
						style={{ width: '100%' }}
					/>
				</Col>
				<Col span={2}>
					<Button onClick={handleLiveClick} type="primary">
						Show Live
					</Button>
				</Col>
			</Row>
			<Table
				dataSource={logs.rows}
				columns={columns}
				size="small"
				pagination={{
					total: logs?.count,
					showSizeChanger: false,
					current: Number(currentPage) || 1,
					pageSize: paginationLimit,
					position: ['bottomCenter'],
					simple: true,
					onChange: updateCurrentPage,
				}}
			/>
			<Modal
				title="Message Text"
				open={showSentMessage}
				onCancel={handleCancel}
				footer={null}
				maskClosable={false}
				style={{ maxHeight: '80vh', overflowY: 'auto' }}
				bodyStyle={{ maxHeight: '60vh', overflowY: 'auto' }}
			>
				<Text style={{ whiteSpace: 'pre-wrap' }}>{messageText}</Text>
			</Modal>
		</div>
	);
}
